import { render, staticRenderFns } from "./CvmatchLoading.vue?vue&type=template&id=0b7f678a&scoped=true"
import script from "./CvmatchLoading.vue?vue&type=script&lang=js"
export * from "./CvmatchLoading.vue?vue&type=script&lang=js"
import style0 from "./CvmatchLoading.vue?vue&type=style&index=0&id=0b7f678a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f678a",
  null
  
)

export default component.exports